export const downloadFile = (fileUrl: string) => {
  const link = document.createElement('a')
  link.href = fileUrl
  link.click()
}
